import { toast } from "react-toastify";

export const tostS = (msg) => {
    var toastId = null;
    var customToastId = 1234;
    if (toast.isActive(toastId)) {
        toastId = toast.success(msg);
    }

    toast.success(msg, {
        toastId: customToastId
    });
};

export const tostE = (msg) => {
    var toastId = null;
    var customToastId = 5678;
    if (toast.isActive(toastId)) {
        toastId = toast.error(msg);
    }

    toast.error(msg, {
        toastId: customToastId
    });
};

export const tostW = (msg) => {
    var toastId = null;
    var customToastId = 9012;
    if (toast.isActive(toastId)) {
        toastId = toast.warn(msg);
    }

    toast.warn(msg, {
        toastId: customToastId
    });
};

export const tostI = (msg) => {
    var toastId = null;
    var customToastId = 3456;
    if (toast.isActive(toastId)) {
        toastId = toast.info(msg);
    }

    toast.info(msg, {
        toastId: customToastId
    });
};